// extracted by mini-css-extract-plugin
module.exports = {"ShareLabel":"ShareContainer_ShareLabel__2rKkE","ShareContainer":"ShareContainer_ShareContainer__OE3_K","Extend":"ShareContainer_Extend__L5tQw","fade":"ShareContainer_fade__1d3HK"};